import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../services/context/authContext/AuthContext";

const PrivateRoute = ({ element: RouteComponent, ...rest }) => {
  const user = useContext(AuthContext);
  const isAdmin = user?.role === "admin";

  if (isAdmin) {
    return <RouteComponent {...rest} />;
  } else if (user && !isAdmin) {
    return <Navigate to={"/"} />;
  } else return <Navigate to={"/login"} />;
};

export default PrivateRoute;
